import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestService } from 'src/app/Services/request/request.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LearnmoreFormDataComponent } from '../learnmore-form-data/learnmore-form-data.component';
import { LearnmorePlanRegistrationComponent } from '../learnmore-plan-registration/learnmore-plan-registration.component';
import { LearnmoreComponent } from '../learnmore/learnmore.component';
import Swal from 'sweetalert2';
import { ConsultConnectionDocumentsComponent } from '../consult-connection-documents/consult-connection-documents.component';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  private lang: string;
  public type: string;
  private newiata: string = "";
  private isNewIata: boolean = false;
  private isUpdateCrm: boolean = false;
  private isUpdateCrmLocation: boolean = false;
  public formGroup: FormGroup;

  isNewRegister: boolean = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly modalService: NgbModal,
    private readonly translate: TranslateService,
    private readonly requestService: RequestService,
    private readonly spinner: NgxSpinnerService,
    formBuilder: FormBuilder
  ) { this.formGroup = formBuilder.group({
    codigo : ['', Validators.required]
  });
}

get codigo() { return this.formGroup.get('codigo'); }

  async ngOnInit() {
    if(environment.showBanner == 'true'){
      this.router.navigateByUrl('/Register')
    }
    this.route.queryParams.subscribe((param) => {
      if (param.type) {
        if (param.type != undefined && param.type != null) {
          this.type = param.type
          sessionStorage.setItem('type', this.type)
        }
        else {
          this.type = sessionStorage.getItem('type')

        }

      }
      else {
        this.type = sessionStorage.getItem('type')
      }
      if (param.lang) {
        this.lang = param.lang;
        sessionStorage.setItem('language',this.lang)
      }
      if (param.newiata) {
        this.newiata = param.newiata;
        sessionStorage.setItem('newiata',this.newiata)
        sessionStorage.setItem('agencyType','1')
      }else{
        sessionStorage.removeItem('newiata')
      }
    });
    
  }

  async redirect() {

    if (this.formGroup.enabled && this.formGroup.valid) {
     await this.spinner.show();

      let rq = await this.requestService.getRequestByCode(this.codigo.value);
      await this.spinner.hide();
      if (rq != null) {
        this.isNewIata = rq.IsNewIata
        this.isUpdateCrm = rq.IsUpdateCrm
        this.isUpdateCrmLocation = rq.IsUpdateCrmLocation

        sessionStorage.setItem("IdRequest", rq.Id.toString())
        sessionStorage.setItem("RequestCode", rq.RequestCode)
        if(this.newiata == ""){
          sessionStorage.removeItem('newiata')
        }
        if(this.isNewIata  == true){
            sessionStorage.setItem('isNewIata', this.isNewIata.toString())
            sessionStorage.setItem('redirectPACO', "true")
            sessionStorage.setItem('agencyType','1')
        }
        else{
          sessionStorage.removeItem('isNewIata')
        }
        if(this.isUpdateCrm == true){
          sessionStorage.setItem('isUpdateCrm', this.isUpdateCrm.toString())
          sessionStorage.setItem('redirectPACO', "true")
        }
        else{
          sessionStorage.removeItem('isUpdateCrm')
        }
        if(this.isUpdateCrmLocation == true){
          sessionStorage.setItem('isUpdateCrmLocation', this.isUpdateCrm.toString())
          sessionStorage.setItem('redirectPACO', "true")
          sessionStorage.setItem('agencyType','1')
        }
        else{
          sessionStorage.removeItem('isUpdateCrmLocation')
        }
        await this.router.navigate(['Register/Main/Request']);
      } else {
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Home.Error'),
          icon: 'error'
        }
        )

      }
    }
    else if (this.formGroup.disabled) {
      sessionStorage.removeItem("IdRequest")
      sessionStorage.removeItem("RequestCode")
      if(this.newiata == ""){
        sessionStorage.removeItem('newiata')
      }
      this.router.navigate(['Register/Main/Request']);
    }

  }

  redirectContinue() {

      this.router.navigate(['Register/Main/Agency-Home']);
  }

  redirectRequest() {

    this.router.navigate(['Register/Main']);
    sessionStorage.removeItem('IdRequest')
    sessionStorage.setItem('RequestCode',"")
    if(this.newiata == ""){
      sessionStorage.removeItem('newiata')
    }
  }

  redirectConsultConnectionDocuments() {

    this.router.navigate(['Register/Main/ConsultConnectionDocuments']);
  }

  openModalLearnFormData(){
    const modalRef = this.modalService.open(LearnmoreFormDataComponent, { size: 'xl' });
    modalRef.componentInstance.type = this.type;
  }

  openModalPlanRegistration() {
 
    const modalRef = this.modalService.open(LearnmorePlanRegistrationComponent, { size: 'xl' });
    modalRef.componentInstance.type = this.type;
  }

  openModalLearnMore(){
    const modalRef = this.modalService.open(LearnmoreComponent, { size: 'xl' });
    modalRef.componentInstance.type = this.type;
  }

  openModalConsultConnectionDocuments(){
    const modalRef = this.modalService.open(ConsultConnectionDocumentsComponent, { size: 'xl' });
  }

}

